import React, {Component} from 'react';
import PropTypes from 'prop-types';

class FileIcon extends Component {
    static propTypes = {
        extension: PropTypes.string.isRequired
    };
    static defaultProps = {};
    state = {};
    fileTypes = {
        '.doc': 'fa-file-word-o',
        '.docx': 'fa-file-word-o',
        '.xls': 'fa-file-excel-o',
        '.xlsx': 'fa-file-excel-o',
        '.txt': 'fa-file-text-o',
        '.ppt': 'fa-file-powerpoint-o',
        '.pptx': 'fa-file-powerpoint-o',
        '.pdf': 'fa-file-pdf-o',
        '.htm': 'fa-file-code-o',
        '.html': 'fa-file-code-o',
        '.rtf': 'fa-file-text-o',
        '.bmp': 'fa-file-image-o',
        '.jpg': 'fa-file-image-o',
        '.jpeg': 'fa-file-image-o',
        '.png': 'fa-file-image-o',
        '.tif': 'fa-file-image-o',
        '.tiff': 'fa-file-image-o',
        '.gif': 'fa-file-image-o',
        '.mp3': 'fa-file-audio-o',
        '.mpeg': 'fa-file-video-o',
        '.zip': 'fa-file-archive-o',
        '.rar': 'fa-file-archive-o'
    };

    render() {
        const {extension} = this.props;
        const className = this.fileTypes[extension];

        if (className)
            return <i className={`fa ${className}`}/>;

        return <i className="fa fa-file-o"/>;
    }
}

export default FileIcon;


// WEBPACK FOOTER //
// ./src/utils/components/FileIcon.js